import createIcon from '../../createIcon';

/**
 * @component @name ContentPasteGo
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC41IDZINi41VjlIMTYuNVY2SDE4LjVWMTJIMjAuNVY2QzIwLjUgNC45IDE5LjYgNCAxOC41IDRIMTQuMzJDMTMuOSAyLjg0IDEyLjggMiAxMS41IDJDMTAuMiAyIDkuMSAyLjg0IDguNjggNEg0LjVDMy40IDQgMi41IDQuOSAyLjUgNlYyMEMyLjUgMjEuMSAzLjQgMjIgNC41IDIySDkuNVYyMEg0LjVWNlpNMTEuNSA0QzEyLjA1IDQgMTIuNSA0LjQ1IDEyLjUgNUMxMi41IDUuNTUgMTIuMDUgNiAxMS41IDZDMTAuOTUgNiAxMC41IDUuNTUgMTAuNSA1QzEwLjUgNC40NSAxMC45NSA0IDExLjUgNFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNy41MSAxNEwxNi4wOSAxNS40MUwxNy42NyAxNi45OUgxMS41VjE4Ljk5SDE3LjY3TDE2LjA5IDIwLjU4TDE3LjUxIDIxLjk5TDIxLjUgMTcuOTlMMTcuNTEgMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ContentPasteGo = createIcon('ContentPasteGo', [
  [
    'path',
    {
      d: 'M4.5 6H6.5V9H16.5V6H18.5V12H20.5V6C20.5 4.9 19.6 4 18.5 4H14.32C13.9 2.84 12.8 2 11.5 2C10.2 2 9.1 2.84 8.68 4H4.5C3.4 4 2.5 4.9 2.5 6V20C2.5 21.1 3.4 22 4.5 22H9.5V20H4.5V6ZM11.5 4C12.05 4 12.5 4.45 12.5 5C12.5 5.55 12.05 6 11.5 6C10.95 6 10.5 5.55 10.5 5C10.5 4.45 10.95 4 11.5 4Z',
      key: 'b8zuck',
    },
  ],
  [
    'path',
    {
      d: 'M17.51 14L16.09 15.41L17.67 16.99H11.5V18.99H17.67L16.09 20.58L17.51 21.99L21.5 17.99L17.51 14Z',
      key: 'yo1gdr',
    },
  ],
]);

export default ContentPasteGo;
